//@ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import StageHeader from "components/StageHeader";
import PageStage from "components/stages/PageStage";

const CompanyPrivacy = ({ className }) => {
  const breadcrumb = [{ label: "Company", href: "/company" }, "Manage privacy"];
  return (
    <PageStage>
      <StageHeader title="Manage privacy" breadcrumb={breadcrumb} />
    </PageStage>
  );
};

CompanyPrivacy.defaultProps = {};

CompanyPrivacy.propTypes = {
  className: PropTypes.string,
};

export default CompanyPrivacy;
